export const getEnhancedModalOpen = (state) => state.enhancedModal.open;
